import { Box, TextareaAutosize } from '@mui/material'
import { textAreaStyle } from '../../constants/styleConstants'
import LabelErrorTAG from '../LabelErrorTAG'
import { ITextareaInput } from './types'

const TextareaInput: React.FC<ITextareaInput> = ({
  label,
  minRows = 5,
  placeholder = '',
  register,
  fieldName,
  error = '',
  previewOnly = false,
}) => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <LabelErrorTAG label={label} error={error} />
      <TextareaAutosize
        {...register(fieldName)}
        style={textAreaStyle}
        minRows={minRows}
        placeholder={placeholder}
        disabled={previewOnly}
      />
    </Box>
  )
}

export default TextareaInput
